/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportPosItems
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.reports.items')
.factory('ReportPosItems', ["$http", "$resource", "$q", "settings", function($http, $resource, $q, settings) {
  var PosItems = $resource(settings.mercHost + '/pos/items');
  var PosItemCategories = $resource(settings.mercHost + '/pos/items/categories');
  /**
   * Get a list of all PosItems in the company database.
   *
   * @memberof ReportPosItems
   * @return {Object} Service promise
   */
  function getAll() {
    return PosItems.query().$promise;
  }

  /**
   * Returns total sales between start and end grouped by PosItem
   *
   * @memberof ReportPosItems
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @return {Object} Service promise
   */
  function getSales(start, end, categoryId, companyId) {
    var deferred = $q.defer();
    var config = {params: {startTime: start, endTime: end, categoryId: categoryId}};

    // Optionally override the company-id header
    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    $http.get(settings.mercHost + '/pos/items/sales', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  /**
   * Returns total orders between start and end grouped by PosItem
   *
   * @memberof ReportPosItems
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @return {Object} Service promise
   */
  function getOrders(start, end, categoryId) {
    var deferred = $q.defer();

    $http.get(settings.mercHost + '/pos/items/orders', {
      params: {startTime: start, endTime: end, categoryId: categoryId}
    })
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  /**
   * Transform an array into an array of objects containing the key, and an array of all values with the corrosponding key.
   * Adapted from https://stackoverflow.com/questions/14446511/most-efficient-method-to-groupby-on-an-array-of-objects#comment64856953_34890276
   */
  function groupBy(array, key, valueAttribute) {
    return array.reduce(function(accumulator, currentValue) {
      var v = currentValue[key];
      var existingGroup = accumulator.find(function(r) { return r && r.key === v;});
      if (existingGroup) {
        existingGroup.values.push(currentValue[valueAttribute]);
      } else {
        accumulator.push({key: v, values: [currentValue[valueAttribute]]});
      }
      return accumulator;
    }, []);
  }

  function itemCategories() {
    return PosItemCategories.query().$promise
    .then(function(categories) {
      return groupBy(categories, 'label', 'id');
    });
  }

  return {
    getAll: getAll,
    getSales: getSales,
    getOrders: getOrders,
    itemCategories: itemCategories
  };
}]);
